import React from 'react';

import AuthPageBase from 'components/AuthPageBase/AuthPageBase';
import ResetPasswordForm from '../containers/ResetPasswordFormContainer';

const ResetPasswordPage = () => <AuthPageBase form={<ResetPasswordForm/>}/>;

export default ResetPasswordPage;